import { useSelector } from "react-redux";
import { useWidgetData } from "../Contexts/dashboardHooks";

export function LogoWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const teamName = data?.type === "logo" ? data.logo.teamName : "Team";
  const initials = data?.type === "logo" ? data.logo.initials : "T";
  const teamLogo: string | undefined = useSelector(
    ({ team }: any) => team.info?.team_logo,
  );

  return (
    <div className="logo-widget" data-grid-id={id}>
      {teamLogo ? (
        <img
          src={teamLogo}
          alt={teamName}
          className="logo-widget-img"
          draggable={false}
        />
      ) : (
        <svg viewBox="0 0 100 100" className="logo-widget-fallback-svg" aria-hidden>
          <defs>
            <linearGradient id={`logo-shine-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#1a3a5c" />
              <stop offset="100%" stopColor="#0d1f33" />
            </linearGradient>
            <linearGradient id={`logo-border-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#c9a227" />
              <stop offset="50%" stopColor="#f4e4a6" />
              <stop offset="100%" stopColor="#c9a227" />
            </linearGradient>
          </defs>
          <circle
            cx="50"
            cy="50"
            r="46"
            fill={`url(#logo-shine-${id})`}
            stroke={`url(#logo-border-${id})`}
            strokeWidth="4"
          />
          <text
            x="50"
            y="58"
            textAnchor="middle"
            className="logo-widget-initials"
            fill="#f4e4a6"
          >
            {initials}
          </text>
        </svg>
      )}
    </div>
  );
}
